// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/get_master_inventory.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Filter, MasterInventoryLineItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetMasterInventoryRequest
 */
export class GetMasterInventoryRequest extends Message<GetMasterInventoryRequest> {
  /**
   * The page number for pagination
   *
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * The number of items per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Optional filter to apply on the inventory items
   *
   * @generated from field: com.neulink.pharmacy.Filter filter = 3;
   */
  filter?: Filter;

  constructor(data?: PartialMessage<GetMasterInventoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMasterInventoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "filter", kind: "message", T: Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMasterInventoryRequest {
    return new GetMasterInventoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMasterInventoryRequest {
    return new GetMasterInventoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMasterInventoryRequest {
    return new GetMasterInventoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMasterInventoryRequest | PlainMessage<GetMasterInventoryRequest> | undefined, b: GetMasterInventoryRequest | PlainMessage<GetMasterInventoryRequest> | undefined): boolean {
    return proto3.util.equals(GetMasterInventoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetMasterInventoryResponse
 */
export class GetMasterInventoryResponse extends Message<GetMasterInventoryResponse> {
  /**
   * List of inventory items
   *
   * @generated from field: repeated com.neulink.pharmacy.MasterInventoryLineItem items = 1;
   */
  items: MasterInventoryLineItem[] = [];

  /**
   * Total number of inventory items matching the filter
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<GetMasterInventoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMasterInventoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: MasterInventoryLineItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMasterInventoryResponse {
    return new GetMasterInventoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMasterInventoryResponse {
    return new GetMasterInventoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMasterInventoryResponse {
    return new GetMasterInventoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMasterInventoryResponse | PlainMessage<GetMasterInventoryResponse> | undefined, b: GetMasterInventoryResponse | PlainMessage<GetMasterInventoryResponse> | undefined): boolean {
    return proto3.util.equals(GetMasterInventoryResponse, a, b);
  }
}

